import { NavigateBackLink } from '@exam-center/components';
import {
  ExamLocationRequestDetailsProvider,
  useExamLocationRequestDetails,
} from '@exam-center/exam-location-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { Box, Label, PageHeader, Text, Flex } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { dayjs } from '@shared/utils';
import { Outlet } from 'react-router-dom';

function ExamLocationRequestHeader() {
  const { examCenterCode } = useParams('/:examCenterCode/exam-location/requests/draft/:requestId');
  const { examLocationRequestInfo } = useExamLocationRequestDetails();

  const title =
    examLocationRequestInfo.nameTh ||
    examLocationRequestInfo.nameEn ||
    examLocationRequestInfo.buildingName ||
    'รายละเอียดคำขอสถานที่สอบ';

  const editedBy = `${examLocationRequestInfo.editedUser?.firstname} ${examLocationRequestInfo.editedUser?.lastname ?? ''}`;

  return (
    <PageHeader
      title={title}
      linkAdornment={
        <NavigateBackLink
          to='/:examCenterCode/exam-location/requests'
          params={{ examCenterCode }}
          label='Back'
        />
      }
      endAdornment={<Label color='info'>แบบร่าง</Label>}
      subtitleSection={
        <Flex sx={{ width: '100%', justifyContent: 'space-between' }}>
          <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
            <Text variant='body2'>เลขที่คำขอ: -</Text>
            <Text variant='body2'>ศูนย์ทดสอบ: {examLocationRequestInfo.examCenterCode}</Text>
          </Flex>
          <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
            <Text variant='body2'>
              Last Updated at: {dayjs(examLocationRequestInfo.editedAt).format('DD-MM-YYYY, HH:mm')}
            </Text>
            <Text variant='body2'>By: {editedBy}</Text>
          </Flex>
        </Flex>
      }
    />
  );
}

export default function ExamLocationManagementLayout() {
  const { requestId } = useParams('/:examCenterCode/exam-location/requests/draft/:requestId');

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.CREATE,
        APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.UPDATE,
        APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW,
      ]}
      options={{
        operator: 'OR',
      }}
    >
      <ExamLocationRequestDetailsProvider examLocationRequestInfoId={requestId}>
        <ExamLocationRequestHeader />
        <Box
          sx={{
            p: (theme) => theme.spacing(6),
            flex: 1,
            gap: (theme) => theme.spacing(6),
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Outlet />
        </Box>
      </ExamLocationRequestDetailsProvider>
    </PermissionGuard>
  );
}
